import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FormsModule } from '@angular/forms';
import { FiChangePasswordTooltipModule } from '@fi-app/components/change-password-tooltip/change-password-tooltip.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiAuthenticateLayoutComponent } from './authenticate-layout/authenticate-layout.component';
import { FiAuthenticateHelpOtherComponent } from './help-other/help-other.component';
import { FiAuthenticateLoginHelpComponent } from './login-help/login-help.component';
import { FiAuthenticateLoginComponent } from './login/login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { FiAuthenticateLoginTokenComponent } from './login-token/login-token.component';
import { FiAuthenticateAgreementComponent } from './agreement/agreement.component';
import { FiAuthenticateModuleService } from './authenticate-module.service';
import { MagicLinkUpdatePasswordDialogComponent } from './magic-link-update-password-dialog/magic-link-update-password-dialog.component';
import { UIRouterModule } from '@uirouter/angular';
import { FiAuthenticateStates } from '@fi-app/authenticate/authenticate-states';
import { FicAppTextModule } from '../../../app-cordova/app/fic-utilities/fic-app-text/fic-app-text.module';
import { MatDividerModule } from '@angular/material/divider';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiLoginCredentialsComponent } from './login/fi-login-credentials/fi-login-credentials.component';
import { ForgotPasswordMultipleContactsComponent } from '@fi-app/authenticate/login-help/forgot-password-multiple-contacts/forgot-password-multiple-contacts.component';
import { FiAuthenticateSharedService } from '@fi-shared/fi-auth-shared/fi-authenticate-shared.service';
import { FiAuthenticateService } from '@fi-app/authenticate/fi-authenticate.service';
import { FiErrorMessageModule } from '@fi-shared/fi-error-message';
import { FiDownloadAppDialogComponent } from '@fi-app/authenticate/login/download-app-dialog/fi-download-app-dialog.component';
import { FiLoginNameInputModule } from '@fi-app/authenticate/login/login-name-input/login-name-input.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatRadioModule,
        MatCheckboxModule,
        MatButtonModule,
        MatSelectModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        UtilitiesModule,
        FiChangePasswordTooltipModule,
        FiAppTextSharedModule,
        FicAppTextModule,
        UIRouterModule.forChild(FiAuthenticateStates),
        MatDividerModule,
        FiValidatingFormModule,
        FiErrorMessageModule,
        FiLoginNameInputModule,
    ],
    declarations: [
        FiAuthenticateLayoutComponent,
        FiAuthenticateHelpOtherComponent,
        FiAuthenticateLoginHelpComponent,
        FiAuthenticateLoginComponent,
        FiAuthenticateLoginTokenComponent,
        FiAuthenticateAgreementComponent,
        MagicLinkUpdatePasswordDialogComponent,
        FiLoginCredentialsComponent,
        ForgotPasswordMultipleContactsComponent,
        FiDownloadAppDialogComponent,
    ],
    exports: [FiAuthenticateLoginComponent],
    providers: [
        FiAuthenticateModuleService,
        {
            provide: FiAuthenticateSharedService,
            useClass: FiAuthenticateService,
        },
    ],
})
export class FiAuthenticateModule {}
